import { render, staticRenderFns } from "./PopupDetailShipLog.vue?vue&type=template&id=f058d228"
import script from "./PopupDetailShipLog.vue?vue&type=script&lang=js"
export * from "./PopupDetailShipLog.vue?vue&type=script&lang=js"
import style0 from "./PopupDetailShipLog.vue?vue&type=style&index=0&id=f058d228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports